import { useState } from 'react';
import Collapse from '@mui/material/Collapse';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import CheckIcon from '@mui/icons-material/Check';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import { getUiLanguage, useUiLanguages } from '@/api/uiLanguages';
import { useLanguageStore, useT } from '@/i18n/i18n';

/** The account menu's language choice (URS UX-02, docs §259): English and the organisation's active packs. Hidden when there are none. */
export default function LanguageMenu({ onDone }: { onDone: () => void }) {
  const t = useT();
  const { data } = useUiLanguages();
  const code = useLanguageStore((s) => s.code);
  const setLanguage = useLanguageStore((s) => s.setLanguage);
  const [open, setOpen] = useState(false);
  const languages = [{ code: 'en', name: 'English' }, ...(data ?? []).filter((l) => l.isActive)];
  if (languages.length < 2) return null;
  const current = languages.find((l) => l.code === code)?.name ?? 'English';

  const choose = async (next: string) => {
    if (next === 'en') setLanguage('en', null);
    else setLanguage(next, await getUiLanguage(next));
    onDone();
  };

  return (
    <>
      <MenuItem onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <ListItemIcon><TranslateOutlinedIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary={t('Language')} secondary={current} />
      </MenuItem>
      <Collapse in={open} unmountOnExit>
        {languages.map((l) => (
          <MenuItem key={l.code} onClick={() => void choose(l.code)} sx={{ pl: 4 }} selected={l.code === code}>
            <ListItemIcon>{l.code === code ? <CheckIcon fontSize="small" /> : null}</ListItemIcon>
            <span lang={l.code}>{l.name}</span>
          </MenuItem>
        ))}
      </Collapse>
    </>
  );
}
